import { jsx as _jsx } from "react/jsx-runtime";
/**
 * FilterTabs Component - Mission filter tabs
 * v13 Section 4.6 - Navigation Components
 */
import { cn } from '@ownyou/ui-design-system';
import { FILTER_TABS } from '../types';
/**
 * Filter tabs: All | Savings | Ikigai | Health
 */
export function FilterTabs({ activeTab = 'all', onTabChange, className, }) {
    return (_jsx("div", { className: cn('flex items-center gap-2', 'overflow-x-auto scrollbar-hide', '-mx-4 px-4', // Extend to edges with padding
        className), role: "tablist", "aria-label": "Filter missions", "data-testid": "filter-tabs", children: FILTER_TABS.map((tab) => {
            const isActive = activeTab === tab.id;
            return (_jsx("button", { type: "button", role: "tab", "aria-selected": isActive, "aria-controls": `${tab.id}-panel`, onClick: () => onTabChange?.(tab.id), className: cn('px-4 py-2 rounded-full', 'font-display text-sm font-bold', 'transition-colors duration-200', 'whitespace-nowrap', 'focus:outline-none focus-visible:ring-2 focus-visible:ring-white', isActive
                    ? 'bg-white text-text-primary shadow-sm'
                    : 'bg-transparent text-text-primary/70 hover:bg-white/30'), "data-testid": `filter-tab-${tab.id}`, children: tab.label }, tab.id));
        }) }));
}
export default FilterTabs;
